"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPartInvestissementPatrimoineGlobalCorporation = void 0;
exports.ESubPartInvestissementPatrimoineGlobalCorporation = {
    percent_between_1_5: "percent_between_1_5",
    percent_between_6_10: "percent_between_6_10",
    percent_between_11_20: "percent_between_11_20",
    percent_greater_20: "percent_greater_20",
};
